if (!customElements.get('nosto-recommendation-item')) {
    customElements.define('nosto-recommendation-item', class nostoRecommendationItem extends HTMLElement {
        constructor() {
            super();
            this.cloned = false;
        }
        connectedCallback() {
            if (this.cloned == true) {
                this.url = new URL(this.getAttribute("data-url"));
                this.handle = this.url.pathname;
                this.recId = this.getAttribute("data-id");
                this.international = this.getAttribute("data-international");
                this.isMinicart = this.getAttribute("data-minicart");
                this.isCompleteLook = this.getAttribute("data-completelook");
                this.data = {};
                this.getProductData();
            }
            this.cloned = true;
        }
        updateProductData() {
            this.discountPercentage = Math.round((100 - (parseInt(this.data.price) / parseInt(this.data.listPrice)) * 100));
            this.isDiscount = false;
            if (parseInt(this.data.price) < parseInt(this.data.listPrice)) {
                this.isDiscount = true;
            }
            this.data.url = this.url.href;
            this.createItem();
        }
        getProductData() {
            var mainEl = this;
            fetch(this.handle + '?view=nosto-api').then(response => response.text()).then(function(data) {
                mainEl.data = JSON.parse(data);
                mainEl.updateProductData();
            });
        }
        createItem() {
            var collection_badge = null;
            var product_icon = '';
            this.data.tags1.forEach((tag) => {
                if (tag.includes('collection_bd:')) {
                    collection_badge = tag.replace('collection_bd:', '');
                }
            });
            this.data.metafields.forEach((meta) => {
              if (meta.key == "images-image_icon") {
                  product_icon = 'icon--' + meta.value.toLowerCase().replaceAll(' ', '-');
              }
            });
            var sizeImages = this.data.alternateImageUrls;
            sizeImages.forEach((image, i) => {
                sizeImages[i] = image.replace('_450x', '').replace('.jpg', '_450x.jpg').replace('.png', '_450x.png').replace('.jpeg', '_450x.jpeg').replace('.webp', '_450x.webp');
            });
            var itemHtml = '<div class="card-wrapper">';
            itemHtml += '<div>';
            itemHtml += '<span class="visually-hidden">' + this.data.name + '</span>';
            itemHtml += '<div class="card card--product" tabindex="-1">';
            itemHtml += '<a href="' + this.data.url + '" class="card__inner full-unstyled-link" track>';
            itemHtml += '<div>';
            itemHtml += '<div class="media media--portrait cc--hover-effect">';
            itemHtml += '<picture class="'+product_icon+'"><img src="' + sizeImages[0] + '" alt="' + this.data.name + '" loading="lazy" class="motion-reduce" width="800" height="967"></picture>';
            itemHtml += '<picture><img src="' + sizeImages[1] + '" alt="' + this.data.name + '" loading="lazy" class="motion-reduce" width="800" height="967"></picture>';
            itemHtml += '</div></div></a>';
            if (collection_badge != null) {
                itemHtml += '<div class="card__badge"><span class="badge caption color-subdued" aria-hidden="true">' + collection_badge + '</span></div>';
            }
            itemHtml += '</div>';
            itemHtml += '<div class="card-information">';
            itemHtml += '<div class="card-information__wrapper">';
            itemHtml += '<div class="card-information__wrapper__main">';
            itemHtml += '<a href="' + this.data.url + '" class="card-information__text h6 full-unstyled-link" track>' + this.data.name.replace(' - FINAL SALE', '').replace(' - SALE', '');
            itemHtml += '</a>';
            itemHtml += '<div class="price p2 card-information__price h4"><dl>';
            if (this.isDiscount == false) {
                itemHtml += '<div class="price__regular">';
                itemHtml += '<dt><span class="visually-hidden visually-hidden--inline">Regular price</span></dt>';
            } else {
                itemHtml += '<div class="price__sale">';
            }
            if (this.international == "true") {
                if (this.isDiscount == false) {
                    itemHtml += '<dd><span class="price-item price-item--regular">' + this.data.price + '</span></dd>';
                } else {
                    var percentDiscount = this.discountPercentage;
                    itemHtml += '<dd class="price__compare"><s class="price-item price-item--regular">' + this.data.listPrice + '</s></dd>';
                    itemHtml += '<dd><span class="price-item price-item--sale">' + this.data.price + '</span><span class="ss__pct--off"><i> ' + percentDiscount + '% Off</i></span></dd>';
                }
            } else {
                if (this.isDiscount == false) {
                    itemHtml += '<dd><span class="price-item price-item--regular">$' + this.data.price + '</span></dd>';
                } else {
                    var percentDiscount = this.discountPercentage;
                    itemHtml += '<dd class="price__compare"><s class="price-item price-item--regular">$' + this.data.listPrice + '</s></dd>';
                    itemHtml += '<dd><span class="price-item price-item--sale">$' + this.data.price + '</span><span class="ss__pct--off"><i> ' + percentDiscount + '% Off</i></span></dd>';
                }
            }
            itemHtml += '</div></dl></div>';
            itemHtml += '</div></div></div>';
            itemHtml += '</div></div>';
            this.insertAdjacentHTML('beforeend', itemHtml);
            if(this.isMinicart == "true" || this.isCompleteLook == "true"){
              this.createProductSelectorMincart();
            } else {
              this.createProductSelector();
            }    
        }
        createProductSelector() {
            var selectorHtml = '<product-card-selector class="card__quickbuy">';
            var liContainer = '';
            selectorHtml += '<form method="post" action="/cart/add" id="product-card-quickbuy-' + this.data.productId + '" accept-charset="UTF-8" class="card__quickbuy__form" enctype="multipart/form-data" novalidate="novalidate" data-options-form="">';
            selectorHtml += '<input type="hidden" name="form_type" value="product">';
            selectorHtml += '<input type="hidden" name="utf8" value="✓">';
            selectorHtml += '<button type="submit" name="add" class="card__quickbuy__submit caption" data-submit="true" data-add-text="Add To Bag" data-sold-text="Sold out" disabled="">Add To Bag</button>';
            selectorHtml += '<select name="id" id="Variants-' + this.data.productId + '" class="hidden" data-options="true">';
            selectorHtml += '<option disabled="" value=""></option>';
            this.data.variants.forEach((variant, i) => {
                var liClasses = 'card__option__value ';
                var liDisable = '';
                if (variant.available == false) {
                    liClasses += 'ss__oos';
                    liDisable = 'disabled';
                }
                selectorHtml += '<option data-options-option="true" data-option1="' + variant.option1 + '" data-option2="' + variant.option2 + '" data-option3="' + variant.option3 + '" value="' + variant.id + '">' + variant.title + '</option>';
                liContainer += '<li class="' + liClasses + '">';
                liContainer += '<input ' + liDisable + ' data-value="true" data-option-index="2" type="checkbox" id="product-collection-grid-quickbuy-' + variant.id + '-' + this.data.options[1].toLowerCase() + '-' + variant.option2.toLowerCase() + '" class="card__option__value__input" value="' + variant.option2 + '">';
                liContainer += '<label for="product-collection-grid-quickbuy-' + variant.id + '-' + this.data.options[1].toLowerCase() + '-' + variant.option2.toLowerCase() + '" class="card__option__value__label caption">' + variant.option2 + '</label>';
                liContainer += '</li>';
            });
            selectorHtml += '</select>';
            selectorHtml += '<div class="card__options">';
            selectorHtml += '<div class="card__option" data-option="true" data-option-index="1">';
            selectorHtml += '<span class="card__option__title caption color-ink">Select your size</span>';
            selectorHtml += '<ul class="card__option__values">';
            selectorHtml += liContainer;
            selectorHtml += '</ul>';
            selectorHtml += '</div>';
            selectorHtml += '</div>';
            selectorHtml += '</form>';
            selectorHtml += '</product-card-selector>';
            if (this.querySelector('product-card-selector') != null) {
                this.querySelector('product-card-selector').remove();
            }
            if (this.data.options[2] == null) {
                this.querySelector('a.card__inner').insertAdjacentHTML('afterend', selectorHtml);
            }
            var productID = this.data.productId;
            var recId = this.recId;
            this.querySelectorAll(".card__option__values .card__option__value:not(.ss__oos) label").forEach((card) => {
              card.addEventListener('click', function(){
                 nostojs(api => {
                  api.recommendedProductAddedToCart(productID, recId);
                });
              })
            })
        }
        createProductSelectorMincart() {
            var selectorHtml = '<product-card-selector class="card__quickbuy">';
            var liContainer = '';
            selectorHtml += '<form method="post" action="/cart/add" id="product-card-quickbuy-' + this.data.productId + '" accept-charset="UTF-8" class="card__quickbuy__form" enctype="multipart/form-data" novalidate="novalidate" data-options-form="">';
            selectorHtml += '<input type="hidden" name="form_type" value="product">';
            selectorHtml += '<input type="hidden" name="utf8" value="✓">';
            selectorHtml += '<label for="Variants-' + this.data.productId + '">Select Your Size:</label>';
            selectorHtml += '<select name="id" id="Variants-' + this.data.productId + '" data-options="true">';
            selectorHtml += '<option disabled="" value=""></option>';
            this.data.variants.forEach((variant, i) => {
                var liClasses = 'card__option__value ';
                var liDisable = '';
                if (variant.available == false) {
                    liClasses += 'ss__oos';
                    liDisable = 'disabled';
                }
                selectorHtml += '<option data-options-option="true" data-option1="' + variant.option1 + '" data-option2="' + variant.option2 + '" data-option3="' + variant.option3 + '" value="' + variant.id + '" ' + liDisable + '>' + variant.option2 + '</option>';
                liContainer += '<li class="' + liClasses + '">';
                liContainer += '<input ' + liDisable + ' data-value="true" data-option-index="2" type="checkbox" id="product-collection-grid-quickbuy-' + variant.id + '-' + this.data.options[1].toLowerCase() + '-' + variant.option2.toLowerCase() + '" class="card__option__value__input" value="' + variant.option2 + '">';
                liContainer += '<label for="product-collection-grid-quickbuy-' + variant.id + '-' + this.data.options[1].toLowerCase() + '-' + variant.option2.toLowerCase() + '" class="card__option__value__label caption">' + variant.option2 + '</label>';
                liContainer += '</li>';
            });
            selectorHtml += '</select>';
            selectorHtml += '<button type="submit" name="add" class="card__quickbuy__submit caption" data-submit="true" data-add-text="Add To Bag" data-sold-text="Sold out">Add<span class="d-only"> To Bag</span></button>';
            selectorHtml += '<div class="card__options">';
            selectorHtml += '<div class="card__option" data-option="true" data-option-index="1">';
            selectorHtml += '<span class="card__option__title caption color-ink">Select your size</span>';
            selectorHtml += '<ul class="card__option__values">';
            selectorHtml += liContainer;
            selectorHtml += '</ul>';
            selectorHtml += '</div>';
            selectorHtml += '</div>';
            selectorHtml += '</form>';
            selectorHtml += '</product-card-selector>';
            if (this.querySelector('product-card-selector') != null) {
                this.querySelector('product-card-selector').remove();
            }
            if (this.data.options[2] == null) {
                this.querySelector('.card-information').insertAdjacentHTML('afterend', selectorHtml);
            }
            var productID = this.data.productId;
            var recId = this.recId;
            this.querySelectorAll(".card__option__values .card__option__value:not(.ss__oos) label").forEach((card) => {
              card.addEventListener('click', function(){
                 nostojs(api => {
                  api.recommendedProductAddedToCart(productID, recId);
                });
              })
            });
            this.querySelectorAll(".card__quickbuy__submit").forEach((bag) => {
              bag.addEventListener('click', function(){
                 nostojs(api => {
                  api.recommendedProductAddedToCart(productID, recId);
                });
                document.querySelector('.cart-drawer__wrapper').scrollTop = 0;
              })
            });
        }
    });
}
if (!customElements.get('nosto-recommendation-slider')) {
    customElements.define('nosto-recommendation-slider', class nostoRecommendationSlider extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            this.products = this.getAttribute("data-products");
            this.recId = this.getAttribute("data-id");
            this.title = this.getAttribute("data-title");
            this.tabs = this.parentElement.getAttribute("data-tab");
            this.international = this.parentElement.parentElement.getAttribute('data-international');
            this.isMinicart = this.parentElement.parentElement.getAttribute("data-minicart");
            this.isCompleteLook = this.parentElement.parentElement.getAttribute("data-completelook");
            this.productsArray = this.products.split(",");
            var itemHtml = '<h3 class="section-title">' + this.title + '</h3><div class="slide-wrap"><div class="nosto-slider" id="collection-slider-' + this.recId + '">';
            this.productsArray.forEach((product) => {
                if (product != '') {
                    itemHtml += '<div class="slide"><nosto-recommendation-item data-completelook="'+this.isCompleteLook+'" data-minicart="'+this.isMinicart+'" data-international="'+this.international+'" data-id="'+this.recId+'" data-url="' + product + '"></nosto-recommendation-item></div>';
                }
            })
            itemHtml += '</div></div>';
            this.innerHTML = itemHtml;
            if(this.isMinicart == "true"){
              this.createSliderMinicart();
            } else if(this.isCompleteLook == "true"){
              this.createSliderCompleteLook();
            }
            else{
              this.createSlider();
              var mainEl = this;
              window.setTimeout(function(){
                var recomendations = mainEl.querySelectorAll('nosto-recommendation-item');
                var min_height = 0;
               recomendations.forEach((recItem) => {
                if(recItem.querySelector('.card-information__wrapper__main') != null){
                 var height = recItem.querySelector('.card-information__wrapper__main').offsetHeight;
                  if(height > min_height){
                    min_height = height;
                  }
                }
              });
              recomendations.forEach((recItem) => {
                 recItem.querySelector('.card-information__wrapper__main').style.minHeight = min_height + 'px';
              });
              }, 1000)
            }  
        }
        createSliderMinicart() {
          var slider = tns({
                "autoWidth": false,
                "items": 2,
                "gutter": 25,
                "slideBy": 2,
                "mouseDrag": true,
                "swipeAngle": false,
                "container": "#collection-slider-" + this.recId,
                "speed": 400,
                "edgePadding": 50,
                "loop": false,
                "responsive": {
                    768: {
                        items: 2,
                        "edgePadding": 50,
                        "slideBy": 1,
                        "gutter": 25
                    },
                    100: {
                        items: 2,
                        "edgePadding": 50,
                        "gutter": 15,
                        "slideBy": 1
                    }
                }
            });
            var mainEl = this;
            window.setTimeout(function(){
            mainEl.style.display = "block";
          }, 500)
        }
      createSliderCompleteLook() {
          var slider = tns({
                "autoWidth": false,
                "items": 4,
                "gutter": 25,
                "slideBy": 2,
                "mouseDrag": true,
                "swipeAngle": false,
                "container": "#collection-slider-" + this.recId,
                "speed": 400,
                "edgePadding": 0,
                "loop": false,
                "swipeAngle": 30,
                "preventScrollOnTouch": 'auto',
                "responsive": {
                    990: {
                        "items": 4,
                        "edgePadding": 0,
                        "slideBy": 2,
                        "gutter": 25
                    },
                    768: {
                        "items": 3,
                        "edgePadding": 0,
                        "slideBy": 2,
                        "gutter": 25
                    },
                    100: {
                        "items": 2,
                        "edgePadding": 0,
                        "gutter": 15,
                        "slideBy": 2
                    }
                }
            });
            var mainEl = this;
            window.setTimeout(function(){
            mainEl.style.display = "block";
          }, 500)
        }
        createSlider() {
            var slider = tns({
                "autoWidth": false,
                "items": 4,
                "gutter": 25,
                "slideBy": 4,
                "mouseDrag": true,
                "swipeAngle": false,
                "container": "#collection-slider-" + this.recId,
                "speed": 400,
                "edgePadding": 150,
                "loop": false,
                "responsive": {
                    1200: {
                        items: 4,
                        "edgePadding": 100,
                        "slideBy": 4
                    },
                    850: {
                        items: 3,
                        "edgePadding": 50,
                        "slideBy": 3
                    },
                    768: {
                        items: 3,
                        "edgePadding": 50,
                        "slideBy": 3
                    },
                    500: {
                        items: 2,
                        "edgePadding": 50,
                        "gutter": 15,
                        "slideBy": 2
                    },
                    100: {
                        items: 2,
                        "edgePadding": 30,
                        "gutter": 15,
                        "slideBy": 2
                    }
                }
            });
            var mainEl = this;
            window.setTimeout(function(){
            mainEl.style.display = "block";
            if(mainEl.parentElement.parentElement.querySelector('.v2-nosto-home-skeleton')){
              mainEl.parentElement.parentElement.querySelector('.v2-nosto-home-skeleton').style.display = "none";
            }
          }, 1000)
        }
    });
}
if (!customElements.get('nosto-tabs')) {
    customElements.define('nosto-tabs', class nostoTabs extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            this.tabs = this.querySelectorAll('.tab-list a');
            this.activeTab = this.querySelector('.tab-list a.active').getAttribute('data-tab');
            this.allSelectors = this.querySelectorAll('[data-tab]');
            this.collectionQuery = this.querySelectorAll('.collection-tab');
            if(this.collectionQuery.length > 0){
              this.callCollections();
            }
            this.tabs.forEach((tab) => {
              tab.addEventListener('click', function(){
                tab.classList.add('active');
                this.activeTab = tab.getAttribute('data-tab');
                this.updateTabs();
              }.bind(this));
            });
            window.setTimeout(function(){
            this.querySelector('.v2-nosto-category-recs-skeleton').style.display = "none";
            this.updateTabs();
            }.bind(this), 1200 )
        }
        updateTabs(){
          this.allSelectors.forEach((tab) => {
            if(tab.getAttribute('data-tab') == this.activeTab){
              tab.classList.add('active');
            }
            else{
              tab.classList.remove('active');
            }
          });
        }
        callCollections(){
          this.collectionQuery.forEach((col) => {
            var collectionId = col.getAttribute('data-collection-id');
            var apiOptions = {};
            apiOptions.products = {
                    facets: ['*'],
                    fields: ['url'],
                    size: 12,
                    from: 0,
                    categoryId: collectionId 
            }
            nostojs(api => {
                api.search(apiOptions, {
                    redirect: false
                }).then(response => {
                    var products = response.products.hits;
                    var sliderUrls = '';
                    products.forEach((product) => {
                      sliderUrls += product.url + ',';
                    });
                    var sliderHTML = '<nosto-recommendation-slider data-nosto="false" data-id="collection-tab--'+collectionId+'" data-title="" data-products="'+sliderUrls+'"></nosto-recommendation-slider>';
                    col.insertAdjacentHTML("afterend", sliderHTML);
              });
            })
    });
}
});
}